<template>
  <div class="partner">
    <div class="partner-header">
      <h4 class="title">Life</h4>
      <p class="intro">
        People are the core of our business. Our employees pride themselves on
        driving change and developing tomorrow’s technology. From farming
        through to sales and marketing, passionate and dedicated individuals are
        what make Mowi the world leader in sustainable aquaculture.
      </p>
    </div>

    <section class="goal">
      <img src="../assets/img/partner.jpg" alt="" />
      <div class="goal-contain">
        <h2>The Blue Revolution</h2>
        <p>
          People are at the heart of our business. Our employees take pride in
          driving change and developing the technologies of tomorrow.
        </p>
        <p>
          From farming to sales and marketing, passionate and dedicated
          individuals have made us a global leader in sustainable aquaculture.
        </p>
      </div>
    </section>

    <section style="margin-bottom: 100px;">
      <div class="values">Values</div>
      <div class="product-advantages-contain">
        <div class="item" v-for="(v, key) in advantagesInfo" :key="key">
          <div class="wrapper">
            <img :src="v.img" alt="" />
            <div class="contain">
              <div class="title">{{ v.title }}</div>
              <div class="intro">{{ v.intro }}</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  name: "Partner",
  data() {
    return {
      advantagesInfo: [
        {
          title: "Passion",
          intro:
            "Passion and dedication, for everything we do and all that we produce, are the key ingredients to our success.",
          img: require("../assets/img/partner1.png"),
        },
        {
          title: "Share",
          intro:
            "We encourage a spirit of openness and transparency. Internally, this creates opportunities for all employees to make an important contribution within our operations.",
          img: require("../assets/img/partner2.jpg"),
        },
        {
          title: "Trust",
          intro:
            "Social responsibility and environmental sustainability is embedded in every level of the business and is at the heart of our corporate culture.",
          img: require("../assets/img/partner3.jpg"),
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.partner {
  width: 1168px;
  margin: 0 auto;
  &-header {
    margin: 100px auto;
    .title {
      margin: 20px;
      font-weight: 700;
      font-size: 44px;
      color: #404041;
      text-align: center;
    }
    .intro {
      width: 828px;
      margin: 0 auto;
      font-size: 15px;
      color: #404041;
      line-height: 26px;
      text-align: center;
    }
  }
}

.goal {
  margin: 80px auto;
  position: relative;
  img {
    width: 758px;
    height: 560px;
  }
  h2 {
    font-weight: 700;
    color: #404041;
    font-size: 32px;
  }
  p {
    font-size: 15px;
    color: #404041;
    line-height: 26px;
  }
  &-contain {
    background: #f6f6f6;
    padding: 100px 60px;
    float: right;
    margin-top: -43%;
    z-index: 12;
    position: relative;
    width: 438px;
  }
}

.values {
  margin-bottom: 50px;
  font-weight: 700;
  color: #404041;
  font-size: 32px;
  text-align: center;
}

.product-advantages-contain {
  display: flex;
  align-content: center;
  justify-content: space-evenly;
  margin-top: 10%;
  // height: 90%;

  .item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex: 1;
    .wrapper {
      padding: 2px;
    }
    img {
      // width: 368px;
      width: 100%;
      height: 227px;
      object-fit: cover;
    }
    .contain {
      margin-top: -4px;
      padding: 20px;
      background-color: #3c3b3b;
      color: white;
      .title {
        font-weight: 700;
        font-size: 26px;
        margin-bottom: 18px;
        color: white;
        text-align: center;
      }
      .intro {
        font-size: 15px;
        line-height: 26px;
        text-align: center;
        height: 120px;
      }
    }
  }
}
</style>
